import { useMemo, useState } from "react";
import { Search } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Input } from "../ui/input";
import { SiteIcon, searchIcons, iconName, ICON_COUNT } from "../site/SiteIcon";

export function IconPicker({ value, onChange, testid = "icon-picker" }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const list = useMemo(() => searchIcons(q), [q]);
  return (
    <Popover open={open} onOpenChange={(o) => { if (o) setQ(""); setOpen(o); }}>
      <PopoverTrigger asChild>
        <button type="button" className="w-full h-9 border rounded-md px-2 flex items-center gap-2 text-sm bg-white hover:bg-stone-50 transition-colors" data-testid={testid}>
          <SiteIcon name={value} size={16} /><span className="truncate">{iconName(value)}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[360px] p-3" align="start">
        <div className="relative mb-3">
          <Search size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-stone-400" />
          <Input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder={`${ICON_COUNT} ikon içinde ara (siyaset, hukuk, kamera…)`} className="pl-8" data-testid={`${testid}-search`} />
        </div>
        <div className="grid grid-cols-8 gap-1 max-h-64 overflow-y-auto" data-testid={`${testid}-results`}>
          {list.map((n) => (
            <button key={n} type="button" title={n} onClick={() => { onChange(n); setOpen(false); }} data-testid={`${testid}-option-${n}`}
              className={`aspect-square rounded-md flex items-center justify-center transition-colors ${iconName(value) === n ? "bg-stone-900 text-white" : "hover:bg-stone-100"}`}>
              <SiteIcon name={n} size={18} />
            </button>
          ))}
          {!list.length && <p className="col-span-8 text-xs text-stone-400 py-4 text-center">Sonuç yok. İngilizce de deneyebilirsiniz (ör. scale, camera).</p>}
        </div>
      </PopoverContent>
    </Popover>
  );
}
